import React from 'react';
const SvgVideo = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#769CC2" d="M22 1l7 7h-7z" />
        <path fill="#5C7896" d="M3 1v30h26V8h-7V1z" />
        <path fill="#1B3F63" opacity={0.2} d="M29 15l-7-7h7z" />
        <path
          d="M9 20h1v1H9v-1zm0-4h1v1H9v-1zm0-4h1v1H9v-1zm0 10h1v1H9v-1zm0-4h1v1H9v-1zm0-4h1v1H9v-1zm0-4h1v1H9v-1zm13 10h1v1h-1v-1zm0-4h1v1h-1v-1zm0-4h1v1h-1v-1zm0 10h1v1h-1v-1zm0-4h1v1h-1v-1zm0-4h1v1h-1v-1zm0-4h1v1h-1v-1zm-11 7h10v6H11v-6zm0-7h10v6H11v-6zM8 9v15h16V9H8z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
});
export default SvgVideo;
SvgVideo.iconName = 'video';
SvgVideo.displayName = 'SvgVideo';
